<template>
  <div>
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <div class="footer"></div>
  </div>
</template>
<script>
export default {
  name: 'License'
}

</script>
<style>
  body {
    background: #fff;
    color: #2E334A;
    font: 12px/22px "PingFangSC-Medium;", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "SimSun", "宋体", "Arial Narrow", sans-serif;;
  }

  #license {
    background: rgb(249, 249, 249);
  }

  .header {
    width: 100%;
    height: 80px;
    background: #fff;
    /*border-bottom: 1px solid #e1e6f1;*/
    -webkit-box-shadow: 0 0 0 1px rgba(52, 63, 75, 0.02), 0 4px 12px 0 rgba(52, 63, 75, 0.06);
    box-shadow: 0 0 0 1px rgba(52, 63, 75, 0.02), 0 4px 12px 0 rgba(52, 63, 75, 0.06);
  }

  /*.header .whc {
    padding-left: 0
  }*/

  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .w1250 {
    width: 1250px;
    margin: 0 auto;
  }

  .headerCon {
    width: 1200px
  }

  * {
    margin: 0;
    padding: 0
  }

  .txt-align-center {
    text-align: center
  }

  .borders {
    border: 1px solid #e9edf4;
    background: #fff
  }

  .borders-shadow {
    background: #fff;
    border: 1px solid #e1e6f1;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
  }

  .w-panel_panel_3yv0w {
    -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
  }

  .h80 {
    height: 80px;
    line-height: 80px;
  }

  .fL {
    float: left;
  }

  .marR8 {
    margin-right: 8px
  }

  .marR20 {
    margin-right: 20px
  }

  .marT {
    margin-top: 8px
  }

  .footer {
    height: 60px;
    width: 100%;
    position: relative;
    margin: 0 auto
  }
  .el-message-box__message{
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 22px;
    color: #07175d;
  }
  .el-loading-spinner i{
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue